<template>
  <div class="about">
    <v-layout align-center justify-center row fill-height>
      <!-- <v-flex xs4 md5>       
          <img src="../assets/HealthLogo.png"/>        
      </v-flex>-->
      <v-flex xs12>

        <h2 class="display-1 mt-4 primary--text">Contact</h2>
        <h3 class="title mt-4 primary--text">Keri Wagner</h3>
        <p class="pt-2">Healthcare Workforce and Primary Care Office Manager<br>
        Office of Rural Health</p>
        <h3 class="title mt-2 pb-2 primary--text">Public Health Division</h3>
        <p>Wyoming Department of Health<br>     
        (307) 777-6512<br>
         keri.wagner@wyo.gov</p>
      </v-flex>
    </v-layout>
    <!-- <h4>
      Contact
      <br>Keri Wagner
      <br>Healthcare Workforce and Primary Care Office Manager
      <br>Office of Rural Health
      <br>Health Readiness and Response Section
      <br>Public Health Division
      <br>Wyoming Department of Health
      <br>6101 Yellowstone Rd., Ste. 420
      <br>Cheyenne, WY 82002
      <br>(307) 777-6512
    </h4>-->
    <!-- <BaseTest></BaseTest>
    <br>-->
    <!-- <Transition appear>
      <BaseIcon :class="$style.icon" name="thumbs-up" spin/>
    </Transition>-->
  </div>
</template>
<script>
export default {
  page: {
    title: 'Contact'
  }
}
</script>

<style lang="scss" module>
@import '@design';

.icon {
  @extend %typography-xlarge;

  display: block;
  margin: 0 auto;

  // stylelint-disable-next-line selector-class-pattern
  &:global(.v-enter-active) {
    transition: opacity 1s;
  }
  // stylelint-disable-next-line selector-class-pattern
  &:global(.v-enter) {
    opacity: 0;
  }
}
h1, h3, h2 {
  color: #616161 !important;
}
p{
  color: #757575 !important;
}
</style>
